import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronDownSmall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconChevronDownSmall"><Path fillRule="evenodd" clipRule="evenodd" d="M12.0002 15.4141L17.4144 9.99985L16.0002 8.58564L12.0002 12.5856L8.00015 8.58564L6.58594 9.99985L12.0002 15.4141Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronDownSmall;
